import { useState } from 'react'
// import { getSchools } from '../apis/school.ts'
import { ReactComponent as SchoolIcon } from '../assets/icons/school-icon.svg'
import { ReactComponent as CloseFilled } from '../assets/icons/close-filled.svg'
import { ReactComponent as VisibleIcon } from '../assets/icons/visible.svg'
import { ReactComponent as InvisibleIcon } from '../assets/icons/invisible.svg'
import { useForm } from 'react-hook-form'
import { postTeachersSignIn } from '../apis/teacher.ts'
import { useNavigate } from 'react-router-dom'

export default function LoginView() {
  //   useEffect(() => {
  //     getSchoolsApi()
  //   }, [])
  //   const [schoolInfo, setSchoolInfo] = useState()
  //   const getSchoolsApi = async () => {
  //     const getSchoolsResponse = await getSchools()

  //     if (getSchoolsResponse.error) {
  //       console.log(getSchoolsResponse)
  //       return
  //     } else {
  //       // console.log(getSchoolsResponse.data)
  //     }
  //   }
  const [showPassword, setShowPassword] = useState(false)
  const navigate = useNavigate()
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm()

  const onSubmit = async (data) => {
    const postTeachersSignInResponse = await postTeachersSignIn({
      userId: data.userId,
      password: data.password,
    })
    if (postTeachersSignInResponse.error) {
      console.log(postTeachersSignInResponse.message)
      return
    }
    // alert('선생님 로그인되었습니다.')
    navigate('/class')
    // reset()
    // setLogin({ isLoggedIn: true })
    // reset()
  }
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className='wrapper'>
        <div className='contents-wrapper'>
          <div className='flex h-full w-full items-center justify-center'>
            <div className='min-w-[340px]'>
              <div className='mb-20 flex items-center justify-center gap-6'>
                <SchoolIcon className='h-32 w-32' />
                <p className='font-poppins text-[32px] font-medium leading-[150%] text-primary-normal'>
                  KlassMate
                </p>
              </div>
              <div className='mb-40 rounded-8 bg-background-secondary py-12 text-center text-body1-medium text-primary-normal'>
                시그마고등학교
              </div>
              <div className='mb-32 flex w-full flex-col items-start gap-16'>
                <div className='flex w-full flex-col gap-4'>
                  <p className='text-body1-semibold text-label-default'>이메일</p>
                  <div className='relative w-full'>
                    <input
                      {...register('userId', {
                        required: '이메일을 입력해주세요',
                      })}
                      type='text'
                      className={`${errors.userId ? 'border-status-negative hover:border-status-negative focus:border-status-negative' : ''} input_default w-full`}
                      placeholder='학교 이메일을 입력하세요'
                    />
                    <span className='text-caption-regular text-status-negative'>
                      {errors?.userId?.message}
                    </span>
                    {watch('userId') && (
                      <button
                        type='button'
                        onClick={() => setValue('userId', '')}
                        className='absolute right-16 top-16 cursor-pointer'
                      >
                        <CloseFilled />
                      </button>
                    )}
                  </div>
                </div>
                <div className='flex w-full flex-col gap-4'>
                  <p className='text-body1-semibold text-label-default'>비밀번호</p>
                  <div className='relative w-full'>
                    <input
                      {...register('password', {
                        required: '비밀번호를 입력해주세요',
                      })}
                      type={showPassword ? 'text' : 'password'}
                      className={`${errors.password ? 'border-status-negative hover:border-status-negative focus:border-status-negative' : ''} input_default w-full`}
                      placeholder='비밀번호를 입력하세요'
                    />
                    <span className='text-caption-regular text-status-negative'>
                      {errors?.password?.message}
                    </span>
                    {watch('password') && (
                      <div className='absolute right-16 top-16 flex gap-16'>
                        <button
                          type='button'
                          onClick={() => setValue('password', '')}
                          className='cursor-pointer'
                        >
                          <CloseFilled />
                        </button>
                        <button
                          type='button'
                          onClick={() => setShowPassword((prev) => !prev)}
                          className='cursor-pointer'
                        >
                          {showPassword ? <InvisibleIcon /> : <VisibleIcon />}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <button type='submit' className='button_solid_primary_lg mb-16 w-full'>
                로그인
              </button>
              <div className='flex items-center gap-12 pl-[48px]'>
                <div className='px-12 py-4 text-body2-medium text-label-info'>비밀번호 재설정</div>
                <div className='h-20 w-[1px] bg-border-default' />
                <div className='px-12 py-4 text-body2-medium text-label-info'>회원가입</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  )
}
